import React from 'react';
import Landing300 from '../../../components/Forms/Landing300';
import { Formik } from 'formik';
import { validationLandingForm } from '../../../utils/validations';
import { withRouter } from 'react-router-dom';
import * as ROUTES from '../../../routes/'; 
import axios from 'axios';
import './main.scss';
import {eventTagM } from '../../../utils/Google/TagManager'

const FormLp = (props) => {
  const formValues = {
    name: '',
    email: '',
    phone: '',
    gender: 'despacho',
  };
 

  const handleSubmit = (values, { setSubmitting, setFieldError }) => {
    const local = window.location.href;
    let typeUser = values.gender == 'despacho' ? true : false;
    let allPhone = `+52${values.phone}`
    setSubmitting(true);
    //Formatear la data a JSON
    let data = JSON.stringify({
      "fields":[{"name":"email","value":values.email},{"name":"firstname","value":values.name},{"name":"phone","value":allPhone},{"name":"despacho_si_no_","value":typeUser}],"context":{"pageUri":local,"pageName":"contactaabogado"},"legalConsentOptions":{"consent":{"consentToProcess":true,"text":"I agree to allow Example Company to store and process my personal data.","communications":[{"value":true,"subscriptionTypeId":999,"text":"I agree to receive marketing communications from Example Company."
    }]}}})

    // Pasar la url , la data y  el header(tipo de contenido = json)
    axios.post(`${process.env.REACT_APP_FIREBASE_URLSERVICE}/send_mails/contacts?portalId=7007313&formGuid=fac36f71-4dd5-4622-9390-cac13d025928`, data, {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin' : '*',
            'Access-Control-Allow-Methods' : 'POST',
        }
      }
    ).then(function (response) {
      
      eventTagM('CA/Thank you page Membresía')
      props.history.push(ROUTES.THANKYOU_PAGE) 
      })
      .catch(function (error) {
        console.log(error);
      }); 
     /*  eventTagM('CA/Thank you page Membresía')
         props.history.push(ROUTES.THANKYOU_PAGE)  */
       /*   props.history.push(`${ROUTES.THANKYOU_PAGE}/${values.name}`)  */

  };
  return (
    <div className="card-form" id="form">
      <div>
        <p className="title-form">
          Regístrate y conoce más de Contacta Abogado®
        </p>
        {/* <p className="text-form">Regístrate y conoce más de Contacta Abogado®</p> */}
      </div>
      <Formik
        initialValues={formValues}
        validationSchema={validationLandingForm}
        onSubmit={handleSubmit}
        render={props => <Landing300 {...props} />}
      />
    </div>
  );
};

export default withRouter(FormLp);
